import React from 'react'
import { useTranslation } from 'react-i18next'
import { AppBar, Tab } from '@mui/material'

import { TabContext, TabList, TabPanel } from '@mui/lab'
import { StateSchema } from '@/hooks/form/models'
import { SportRestrictionObject } from '@/state/bonus-engine/models'

import useStyles from './style'
import TableRestrictions from './table/index.component'

type Props = {
  handleOnChange: (name: string, value: any) => void
  state: StateSchema
  handleOnClickSetEnable: (
    type: string,
    value: number | string,
    all?: boolean,
  ) => void
  handleOnClickSetDisable: (
    type: string,
    value: number | string,
    all?: boolean,
  ) => void
  handleOnClickSetDiscardContribution: (
    type: string,
    value: number | string,
  ) => void
  getProductsInitValues: () => SportRestrictionObject[]
  getWagerTypeInitValues: (hideElement?: boolean) => SportRestrictionObject[]
  getSportInitValues: (hideElement?: boolean) => SportRestrictionObject[]
  bonusType: string
  hideTypes?: boolean
}

const SportTabsRestrictions = ({
  state,
  bonusType,
  handleOnClickSetDisable,
  handleOnClickSetDiscardContribution,
  handleOnClickSetEnable,
  getProductsInitValues,
  getSportInitValues,
  getWagerTypeInitValues,
  hideTypes,
}: Props) => {
  const [value, setValue] = React.useState(bonusType === '3' ? '2' : '1')

  const { classes } = useStyles()

  const handleChange = (event: any, newValue: string) => {
    setValue(newValue)
  }

  const { t } = useTranslation()

  const getTabList = () => {
    if (bonusType === '3') {
      return (
        <TabList
          onChange={handleChange}
          aria-label="simple tabs"
          variant="fullWidth"
          className={classes.tabs}
          indicatorColor="primary"
        >
          <Tab label={t('restrictions.sports')} value="2" />
          <Tab label={t('restrictions.wagerType')} value="3" />
        </TabList>
      )
    } else {
      return (
        <TabList
          onChange={handleChange}
          aria-label="simple tabs"
          variant="fullWidth"
          className={classes.tabs}
          indicatorColor="primary"
        >
          <Tab label={t('restrictions.product')} value="1" />
          <Tab label={t('restrictions.sports')} value="2" />
          <Tab label={t('restrictions.wagerType')} value="3" />
        </TabList>
      )
    }
  }

  return (
    <>
      <TabContext value={value}>
        <AppBar position="static" className={classes.appBar}>
          {getTabList()}
        </AppBar>
        <TabPanel value="1" className={classes.tableRestrictions}>
          <TableRestrictions
            type="product"
            items={state.products.value}
            listItems={getProductsInitValues()}
            handleOnClickSetDisable={handleOnClickSetDisable}
            handleOnClickSetEnable={handleOnClickSetEnable}
            handleOnClickSetDiscardContribution={
              handleOnClickSetDiscardContribution
            }
          />
        </TabPanel>
        <TabPanel value="2" className={classes.tableRestrictions}>
          <TableRestrictions
            type="sport"
            items={state.sports.value}
            listItems={getSportInitValues(hideTypes)}
            handleOnClickSetDisable={handleOnClickSetDisable}
            handleOnClickSetEnable={handleOnClickSetEnable}
            handleOnClickSetDiscardContribution={
              handleOnClickSetDiscardContribution
            }
          />
        </TabPanel>
        <TabPanel value="3" className={classes.tableRestrictions}>
          <TableRestrictions
            type="wagerType"
            items={state.wagerTypes.value}
            listItems={getWagerTypeInitValues(hideTypes)}
            handleOnClickSetDisable={handleOnClickSetDisable}
            handleOnClickSetEnable={handleOnClickSetEnable}
            handleOnClickSetDiscardContribution={
              handleOnClickSetDiscardContribution
            }
          />
        </TabPanel>
      </TabContext>
    </>
  )
}

export default SportTabsRestrictions
